import { RouteConfig } from 'vue-router';
const PAGE_TITLE = '2022十大渝商评选';
const baseUrl = '20220803YSPX';
const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./ViewHolder.vue'),
  redirect: `/${baseUrl}/home`,
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'home',
      name: `${baseUrl}-home`,
      component: () => import('./pages/News.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'rule',
      name: `${baseUrl}-rule`,
      component: () => import('./pages/Rule.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'link',
      name: `${baseUrl}-link`,
      component: () => import('./pages/Link.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
  ],
};

export default route;
